import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';


@Component({
  selector: 'app-turns-desk-resume-card',
  templateUrl: './turns-desk-resume-card.component.html',
  styleUrls: ['./turns-desk-resume-card.component.scss']
})
export class TurnsDeskResumeCardComponent implements OnInit, OnDestroy {

  @Input() desk;
  @Input() deskTypes;
  @Input() smsList;
  @Input() ticketList;
  @Input() viewDisposition;
  centerList;
  updateDeskStatusSubscription: Subscription;
  deleteDeskSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public toggleStatus() {
    this.updateDeskStatusSubscription = this.desksTurnsService.updateDeskStatus(this.desk.InternalId).subscribe(
      (res) => {
        this.desk.Active = res['data']['status'];
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../../desk', this.desk.InternalId], { relativeTo: this.activatedRoute });
    }
  }

  public deleteDesk() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['turns-page.delete desk', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteDeskSubscription = this.desksTurnsService.deleteDesk(this.desk.InternalId).subscribe(
          (res) => {
            this.desksTurnsService.refreshDesks();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public getCenter() {
    if (this.desk && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.desk.CenterInternalId) {
          return center.CenterName;
        }
      }
    } else {
      return '-';
    }
  }

  public getLocationCount() {
    if (this.desk && this.desk.LocationsBound) {
      return this.desk.LocationsBound.length;
    } else {
      return '-';
    }
  }

  public getDeskType() {
    if (this.desk && this.deskTypes && this.deskTypes.length > 0) {
      for (const deskType of this.deskTypes) {
        if (deskType.InternalId === this.desk.TurnTypeInternalId) {
          return deskType.TypeName;
        }
      }
      return '-';
    } else {
      return '-';
    }
  }

  public getSmsTemplate() {
    if (this.desk && this.smsList && this.smsList.length > 0) {
      for (const smsTemplate of this.smsList) {
        if (smsTemplate.InternalId === this.desk.SmsInternalId) {
          return smsTemplate.SmsName;
        }
      }
      return '-';
    } else {
      return '-';
    }
  }

  public getTicketTemplate() {
    if (this.desk && this.ticketList && this.ticketList.length > 0) {
      for (const ticketTemplate of this.ticketList) {
        if (ticketTemplate.InternalId === this.desk.TicketInternalId) {
          return ticketTemplate.TicketName;
        }
      }
      return '-';
    } else {
      return '-';
    }
  }

  ngOnDestroy() {
    if (this.updateDeskStatusSubscription) { this.updateDeskStatusSubscription.unsubscribe(); }
    if (this.deleteDeskSubscription) { this.deleteDeskSubscription.unsubscribe(); }
  }
}
